var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn_arrow_right",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icn_arrow_down",
    transform: "translate(7.000000, 7.000000) rotate(90.000000) translate(-7.000000, -7.000000) translate(0.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bounding_box",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1539624,1.21773566 C10.4442766,1.50804988 10.4442766,1.97874223 10.1539624,2.26905645 L5.42315742,7.00009827 L10.1539624,11.7309436 C10.4442766,12.0212578 10.4442766,12.4919501 10.1539624,12.7822643 C9.86364815,13.0725786 9.3929558,13.0725786 9.10264158,12.7822643 L3.84603763,7.5256604 C3.55572341,7.23534618 3.55572341,6.76465383 3.84603763,6.47433961 L9.10264158,1.21773566 C9.3929558,0.927421445 9.86364815,0.927421445 10.1539624,1.21773566 Z",
    id: "shape_arrow",
    fill: "#333333",
    fillRule: "nonzero",
    transform: "translate(7.000000, 7.000000) rotate(90.000000) translate(-7.000000, -7.000000) "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnArrowRight);
export default __webpack_public_path__ + "static/media/icn_arrow_right.256badf686afcd9dee751fe764e29502.svg";
export { ForwardRef as ReactComponent };